import React, { useContext, useState } from "react";

import { Button, Typography } from "@mui/material";

import { activateModuleSubscription } from "api/endpoints/subscription";
import { callOptionsHeaders } from "api/helpers";
import ConfirmDialog from "components/shared/confirm-dialog";
import { MODULE_ACTION_BUTTON_MIN_WIDTH } from "constants/index";
import { GrpcError, SnackbarContext } from "context/snackbar-context";

interface ActivateModuleSubscriptionProps {
  orgId: string;
  regionCode: string;
  moduleName: string;
  moduleLabel: string;
  onSuccess: () => void;
}

const ActivateModuleSubscription = ({
  orgId,
  regionCode,
  moduleName,
  moduleLabel,
  onSuccess,
}: ActivateModuleSubscriptionProps) => {
  const { showError } = useContext(SnackbarContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleConfirm = async () => {
    setIsSaving(true);
    try {
      await activateModuleSubscription(
        { orgId, moduleName },
        callOptionsHeaders(regionCode, orgId),
      );
      setOpenDialog(false);
      onSuccess();
    } catch (err) {
      showError(err as GrpcError);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Button
        sx={{ mt: 1, mr: 2, minWidth: MODULE_ACTION_BUTTON_MIN_WIDTH }}
        data-testid={`${moduleName}-activate-subscription`}
        variant="contained"
        color="primary"
        onClick={() => setOpenDialog(true)}
      >
        ACTIVATE
      </Button>

      <ConfirmDialog
        title="Activate Module Subscription"
        cancelBtnLabel="CANCEL"
        confirmBtnLabel="ACTIVATE"
        open={openDialog}
        setOpen={setOpenDialog}
        disabled={isSaving}
        disableCancelBtn={isSaving}
        disableCloseOnConfirm
        onConfirm={handleConfirm}
        onCancel={() => setOpenDialog(false)}
      >
        <Typography data-testid={`${moduleName}-activate-subscription-form`}>
          Activate the {moduleLabel} subscription for this organization?
        </Typography>
      </ConfirmDialog>
    </>
  );
};

export default ActivateModuleSubscription;
